import React from 'react';
import { Link, Outlet } from "react-router-dom";

class Navbar extends React.Component {
    constructor(props){
        super(props);
        this.state = {
           loggedIn: props.loggedIn,
           isAdmin: props.isAdmin
        };
        this.handleLogout = this.handleLogout.bind(this);
    }

    handleLogout(e){
        window.sessionStorage.removeItem("jwtToken");
        window.sessionStorage.removeItem("userMail");
        window.sessionStorage.removeItem("isAdmin");
        this.props.handleLogout(null, null, null);
        window.location.pathname = "/";
    }

    render() {
    if (this.state.loggedIn === false) {
        return (<>
                    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css" />
                    <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
                    <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js"></script>

                    <nav className="navbar navbar-inverse">
                        <h4 style={{color: "white", paddingTop: "5px",paddingLeft: "20px"}}>Statistic tool</h4>
                    </nav>
                    <Outlet />
               </>);
    }

    return (
    <>
        <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css" />
        <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
        <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js"></script>

        <nav className="navbar navbar-inverse">
            <h4 style={{float: "left", color: "white", paddingTop: "5px",paddingLeft: "20px"}}>Statistic tool</h4>
            <div className="container-fluid" style={{float:"right"}}>
                <Link to="/settings">
                    <span title="User settings"
                        style={{fontSize: "20px", color: "white", paddingTop: "14px", paddingLeft: "10px"}}
                        className="glyphicon glyphicon-cog" />
                </Link>
                <span title="Logout" onClick={this.handleLogout}
                    style={{fontSize: "20px", color: "white", paddingTop: "14px", paddingLeft: "15px"}}
                    className="glyphicon glyphicon-log-out" />
            </div>
            <span style={{float:"right", fontSize: "16px", color: "white", paddingTop: "14px"}}>{this.props.userMail}</span>
            {this.state.isAdmin ?
                <Link to="/admin/invite">
                    <button style={{float: "right", marginTop:"8px", marginRight:"14px", paddingLeft:"25px", paddingRight:"25px"}}
                    className="btn btn-primary">Send user invite</button>
                </Link> : ""
            }
        </nav>
        <Outlet />
    </>
    );
    }
}

export default Navbar;